import { render, staticRenderFns } from "./CompanyPayrollInfo.vue?vue&type=template&id=0a3dee62&scoped=true&"
import script from "./CompanyPayrollInfo.vue?vue&type=script&lang=js&"
export * from "./CompanyPayrollInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a3dee62",
  null
  
)

export default component.exports